module.exports = __webpack_public_path__ + "img/aniImg3.e9815618.png";